"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Icon_1 = require("../Icon");
var ChevronLeft = function (props) { return (React.createElement(Icon_1.default, __assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M14.05 16.25l-3.749-3.749L14.05 8.75 13.3 8l-4.5 4.501 4.5 4.5z" }))); };
exports.default = ChevronLeft;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChevronLeft.js.map